import awsconfig_dev from './web-config-exmarx-office-api-us-east-1-dev-v1';
import awsconfig_staging from './web-config-exmarx-office-api-us-east-1-staging-v1';
import awsconfig_prod from './web-config-exmarx-office-api-us-west-2-prod-v1';

let awsconfig = awsconfig_prod;
let endpoints = [
    {
        name: 'officeApi',
        endpoint: 'https://office-api.exmarx.com/v1',
        region: 'us-west-2'
    }
];

switch(__STAGE__){
    case 'development':
        console.warn(`Using development environment (__STAGE__=development).`);
        awsconfig = awsconfig_dev;
        endpoints = [
            {
                name: 'officeApi',
                endpoint: 'https://office-api-development.exmarx.com/v1',
                region: 'us-east-1'
            }
        ];
        break;
    case 'staging':
        console.warn(`Using staging environment (__STAGE__=staging).`);
        awsconfig = awsconfig_staging;
        endpoints = [
            {
                name: 'officeApi',
                endpoint: 'https://office-api-staging.exmarx.com/v1',
                region: 'us-east-1'
            }
        ];
        break;
    default:
        console.warn(`Using production environment (__STAGE__=production).`);
        break;
}

// overwrite endpoints with custom domains
awsconfig.aws_cloud_logic_custom = endpoints;
awsconfig.endpoints = endpoints;
awsconfig.officeApi = endpoints.find(x=>x.name==='officeApi').endpoint;

export default awsconfig;